export default __webpack_public_path__ + "static/media/13.2ddc31c1.jpg";